/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { useField, useFormikContext } from "formik";
import CheckboxPR from "../../PrimeReact/CheckboxPR";

export default function Checkbox({ ...props }) {
  const [field] = useField({ ...props, type: "checkbox" });
  const { values } = useFormikContext();

  return (
    <>
      <CheckboxPR field={field} props={props} values={values} />
    </>
  );
}
